import { getGamesFeedAPI } from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      gamesCategory: [],
      isLoading: false,
    },
  },

  getters: {
    getGamesCategory: (state) => state.data.gamesCategory,
  },

  actions: {
    actionGetGamesCategoryList({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getGamesFeedAPI(env).then(
          (response) => {
            commit("SET_GAMES_CATEGORY", response);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(response);
          },
          (error) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },
  },

  mutations: {
    SET_GAMES_CATEGORY(state, payload) {
      state.data.gamesCategory = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
